import React from 'react';
import { FormattedMessage } from 'react-intl';
import { serviceAnnouncementDatetime } from '@/utils/dateHelper';

const AnnouncementHeadline = ({ headline, dateTimeFrom, dateTimeTo }) => (
  <p className="bold mb-2 f-12">
    {dateTimeFrom === null && dateTimeTo === null && (<>{headline}</>)}
    {dateTimeFrom !== null && dateTimeTo === null && (
      <FormattedMessage
        id="notifications.announcements.headline.from"
        values={{ headline, dateFrom: serviceAnnouncementDatetime(dateTimeFrom) }}
      />
    )}
    {dateTimeFrom === null && dateTimeTo !== null && (
      <FormattedMessage
        id="notifications.announcements.headline.to"
        values={{ headline, dateTo: serviceAnnouncementDatetime(dateTimeTo) }}
      />
    )}
    {dateTimeFrom !== null && dateTimeTo !== null && (
      <FormattedMessage
        id="notifications.announcements.headline"
        values={{
          headline,
          dateFrom: serviceAnnouncementDatetime(dateTimeFrom),
          dateTo: serviceAnnouncementDatetime(dateTimeTo),
        }}
      />
    )}
  </p>
);

export default AnnouncementHeadline;
